













































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import Multiselect from "vue-multiselect";
import VueElementLoading from "vue-element-loading";
import store from "@/services/store";
import { IProject, CurProjectDataClass } from "./gip-types";
import axios from "axios";
import CurrentProjectCard from "./cur-project-card.vue";
import { Prop, Watch } from "vue-property-decorator";
import { debounce } from "lodash";

type AbpResponse = {
    abps: Array<{
        abp: number;
        name_ru: string;
        name_kk: string;
        begDate: string;
        endDate: string;
    }>;
    currentAbpValid: boolean | null;
};

type UsageMode = "transfers" | "alteration" | "ipf" | "events";

@Component({
    name: "currentProjects",
    components: {
        multiselect: Multiselect,
        loading: VueElementLoading,
        CurrentProjectCard,
    },
})
export default class CurrentProjects extends Vue {
    $refs!: {
        drop: HTMLFormElement;
        addRef: HTMLFormElement;
        region: HTMLFormElement;
        abp: HTMLFormElement;
        prg: HTMLFormElement;
        snpReg: HTMLFormElement;
        period: HTMLFormElement;
        status: HTMLFormElement;
        tpCard: HTMLFormElement;
        curProjectList: HTMLFormElement;
        code: HTMLFormElement;
        loadMoreTrigger: HTMLElement;
    };
    @Prop({ type: Number, required: true }) readonly activeTab!: number;
    private selectedCode: any = null;
    private isCodeSelected: boolean = false;
    private codeList: any = [];
    private tempSelectedType: { code: string; text: any } | null = {
        code: "current",
        text: this.$t("modules.bank_projects.filter_params.type_exp.cur_prj"),
    };
    private selectedType: { code: string; text: any } | null = {
        code: "current",
        text: this.$t("modules.bank_projects.filter_params.type_exp.cur_prj"),
    };
    private typeList: Array<{ code: string; text: any }> = [
        {
            code: "current",
            text: this.$t(
                "modules.bank_projects.filter_params.type_exp.cur_prj"
            ),
        },
        {
            code: "other",
            text: this.$t(
                "modules.bank_projects.filter_params.type_exp.other_prj"
            ),
        },
    ];
    private regionList: any[] = [];
    private selectedRegion: any = null;
    private abpList: any[] = [];
    private abpNewList: any[] = [];
    private selectedAbp: any = null;
    private abpItem: string = "AБП";
    private prgList: any[] = [];
    private selectedPrg: any = null;
    private regionsSnp: any[] = [];
    private selectedRegSnp: any = null;
    private bpItem: string = "БП";
    private realYearList: any[] = [];
    private selectedFromYear: number | null = new Date().getFullYear();
    private selectedToYear: number | null = null;
    private isActive: boolean = true;
    private isArchived: boolean = true;

    private tempSelectedCode: any = null;
    private tempSelectedRegion: any = null;
    private tempSelectedAbp: any = null;
    private tempSelectedPrg: any = null;
    private tempSelectedRegSnp: any = null;
    private tempSelectedFromYear: number | null = new Date().getFullYear();
    private tempSelectedToYear: number | null = null;
    private tempIsActive: boolean = true;
    private tempIsArchived: boolean = true;

    private fundingSrcList: any[] = [];
    private selectedFunding: any = null;
    private projectPrgList: any[] = [];
    private selectedProjectPrg: any = null;
    private selectedBranch: any = null;
    private branchList: any[] = [];
    private selectedUnit: any = null;
    private selectedIndicator: any = null;
    private unitList: any[] = [];
    private mode: "view" | "edit" | "create" = "view";
    private isSaving: boolean = false;
    private isEditing: boolean = false;
    private isAddModalVisible: boolean = false;
    private showCloseModal: boolean = false;
    private isEdited: boolean = false;
    private originalTpData: any = {};
    private response: boolean = false;
    private showDetailForm: boolean = false;
    private bar: number = 0;
    private loading: boolean = false;
    private isInitialized = false;
    private showDelModal: boolean = false;
    private oblKato: any = null;
    private backList = true;
    private curProjectList: IProject[] = [];
    private tpData: CurProjectDataClass = new CurProjectDataClass();
    private selectedProject: CurProjectDataClass | null = null;
    private backProjectCardForm: boolean = true;
    private goalIndicatorList: any[] = [];
    private get projectTableFields() {
        const isOtherTypeSelected = this.selectedType?.code === "other";
        let fields = [
            {
                label: "№",
                key: "nom",
            },
            {
                label: this.$t("modules.bank_projects.filter_params.code"),
                key: "code",
                sortable: true,
            },
            {
                label: this.$t(
                    "modules.bank_projects.table_fields.project_name"
                ),
                key: "name",
                sortable: true,
            },
            {
                label: this.$t("modules.bank_projects.filter_params.abp"),
                key: "abp",
                sortable: true,
            },
            {
                label: this.$t("modules.bank_projects.filter_params.bp"),
                key: "prg",
                sortable: true,
            },
            {
                label: this.$t(
                    "modules.bank_projects.filter_params.period_real"
                ),
                key: "period",
                sortable: true,
            },
            {
                label: this.$t("modules.bank_projects.filter_params.location"),
                key: "location",
                sortable: true,
            },
            {
                label: this.$t("modules.bank_projects.table_fields.sum_budget"),
                key: "budget_sum",
                sortable: true,
            },
            {
                label: this.$t(
                    "modules.bank_projects.filter_params.status.title"
                ),
                key: "projectStatus",
                sortable: true,
            },
            {
                label: "",
                key: "extra",
            },
        ];

        if (isOtherTypeSelected) {
            fields = fields.filter(
                (field) =>
                    // field.key !== "prg" &&
                    field.key !== "location" && field.key !== "budget_sum"
            );
        }

        return fields;
    }

    private get items(): any {
        return {
            code: this.$t("modules.bank_projects.filter_params.code"),
            region: this.$t("modules.bank_projects.filter_params.region"),
            abp: this.$t("modules.bank_projects.filter_params.abp"),
            prg: this.$t("modules.bank_projects.filter_params.bp"),
            period_real: this.$t(
                "modules.bank_projects.filter_params.period_real"
            ),
            location: this.$t("modules.bank_projects.filter_params.location"),
            type_exp: this.$t(
                "modules.bank_projects.filter_params.type_exp.title"
            ),
        };
    }

    private get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    get yearBreadcrumb(): string {
        const fromLabel = this.$t(
            "modules.bank_projects.filter_params.from"
        ) as string;
        const toLabel = this.$t(
            "modules.bank_projects.filter_params.to"
        ) as string;
        const isKk = this.curLanguage === "kk";
        if (this.selectedFromYear && this.selectedToYear) {
            return `${this.selectedFromYear} - ${this.selectedToYear}`;
        }
        if (this.selectedFromYear) {
            return isKk
                ? `${this.selectedFromYear} ${fromLabel}`
                : `${fromLabel} ${this.selectedFromYear}`;
        }
        return isKk
            ? `${this.selectedToYear} ${toLabel}`
            : `${toLabel} ${this.selectedToYear}`;
    }

    private limit = 50;
    private offset = 0;
    private hasMore = true;
    private observer: IntersectionObserver | null = null;

    get userId() {
        return store.getters.user_uuid;
    }

    public get oblCode(): string {
        return (this.oblKato || "").padStart(2, "0");
    }

    get hasEditAccess(): boolean {
        const moduleCode = "003.008.002";
        const accessLevel = this.$store.state.user.userModules.find(
            (it: any) => it.modules === moduleCode
        )?.access_level;
        return accessLevel >= 2;
    }

    public async created() {
        try {
            this.$watch("tempSelectedType", (newValue, oldValue) => {
                if (newValue?.code === oldValue?.code) {
                    return;
                }

                if (newValue?.code === "other") {
                    this.getAbpWithoutRegion();
                    this.resetFilterForOtherType();
                }

                if (newValue?.code === "current") {
                    this.resetFilterData();
                }
            });

            this.$watch("tempSelectedRegion", (newValue) => {
                this.tempSelectedAbp = null;
                this.loadAbpData(newValue, true);
            });

            this.$watch("selectedRegion", (newValue) => {
                if (this.tempSelectedRegion) {
                    if (this.tempSelectedType?.code === "current") {
                        this.selectedAbp = this.tempSelectedAbp;
                    } else {
                        this.selectedAbp = null;
                    }
                }

                if (
                    this.tpData.srcData === "current" &&
                    this.showDetailForm &&
                    newValue?.code
                ) {
                    this.loadAbpForCreation();
                }
            });

            this.$watch("tempSelectedAbp", async (newValue) => {
                this.prgByAbpCache = {};

                this.tempSelectedPrg = null;

                if (
                    this.tempSelectedType?.code === "current" ||
                    this.tempSelectedType?.code === "other"
                ) {
                    await this.loadPrgData(newValue);
                }
            });

            this.$watch("selectedAbp", (newValue, oldValue) => {
                if (!newValue) return;

                this.tpData.abp = newValue.abp || "";

                if (newValue.abp === oldValue?.abp) return;

                if (
                    this.tpData.srcData === "current" ||
                    this.tpData.srcData === "other"
                ) {
                    if (this.mode === "create" || this.mode === "edit") {
                        this.selectedPrg = null;
                        this.tpData.prg = null as unknown as string;
                        this.loadPrgData(newValue);
                    } else if (this.mode === "view") {
                        this.loadPrgData(newValue);
                    }
                }
            });

            this.$watch("tempSelectedCode", (newValue) => {
                this.isCodeSelected = !!newValue;
                if (this.isCodeSelected) {
                    this.resetFiltersForCode();
                }
                this.getAbpWithoutRegion();
            });

            this.$watch("isSaving", (newValue: boolean) => {
                if (newValue) {
                    this.getCurProjectList();
                    this.getCodeList();
                }
            });

            const debouncedLoad = debounce(() => {
                if (this.tpData.srcData === "current") {
                    this.loadAbpForCreation();
                } else {
                    this.loadUserAbpByPeriod();
                }
            }, 500);

            this.$watch(
                () => [
                    this.tpData?.dateFromForInput,
                    this.tpData?.dateToForInput,
                ],
                () => {
                    if (this.tpData?.id && this.mode === "view") {
                        debouncedLoad();
                        return;
                    } else if (!this.tpData?.id && this.mode === "create") {
                        this.selectedAbp = null;
                        debouncedLoad();
                    } else if (this.tpData?.id && this.mode === "edit") {
                        this.tpData.abp = "";
                        this.selectedAbp = null;
                        debouncedLoad();
                    }
                }
            );

            this.$watch("curLanguage", async () => {
                if (!this.isInitialized) return;
                if (this.showDetailForm) {
                    if (this.mode === "view" && this.tpData?.id) {
                        await this.getDetailProjectInfo({
                            id: this.tpData.id,
                        });
                    }
                    return;
                }
                this.offset = 0;
                this.hasMore = true;
                this.curProjectList = [];
                this.getCurProjectList();
            });

            await this.fetchObl();
            await this.loadRegion();
            await this.loadRegionsSnp();
            await this.getCodeList();
            await this.getProjectPrg();
            await this.getUnits();
            await this.getFundingSrc();
            await this.getProjectBranches();
            await this.getCurProjectList();
            await this.getIndicatorList();

            this.isInitialized = true;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t("modules.bank_projects.messages.init_err_msg")
                    ),
                    error.message
                );
            }
        }
    }

    public mounted() {
        this.$nextTick(() => {
            this.observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        if (!this.isInitialized || this.loading) return;
                        this.getCurProjectList();
                    }
                },
                {
                    root: null,
                    rootMargin: "200px",
                    threshold: 0,
                }
            );

            const el = this.$refs.loadMoreTrigger;
            if (el) {
                this.observer.observe(el);
            }
        });
    }

    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private getProjectStatusLabel(status: string): string {
        if (status === "active")
            return this.$t(
                "modules.bank_projects.filter_params.status.active"
            ) as string;
        if (status === "archived")
            return this.$t(
                "modules.bank_projects.filter_params.status.archive"
            ) as string;
        if (status === "all")
            return this.$t(
                "modules.bank_projects.filter_params.status.all"
            ) as string;
        return "";
    }

    private validateYears() {
        const isValidYear = (year: any): boolean => {
            return !isNaN(year) && Number(year) >= 1900 && Number(year) <= 9999;
        };

        if (!this.tempSelectedFromYear && !this.tempSelectedToYear) {
            this.tempSelectedFromYear = new Date().getFullYear();
        }

        if (
            this.tempSelectedFromYear &&
            !isValidYear(this.tempSelectedFromYear)
        ) {
            this.tempSelectedFromYear = null;
        }
        if (this.tempSelectedToYear && !isValidYear(this.tempSelectedToYear)) {
            this.tempSelectedToYear = null;
        }

        if (this.tempSelectedFromYear && this.tempSelectedToYear) {
            if (this.tempSelectedFromYear > this.tempSelectedToYear) {
                this.tempSelectedFromYear = this.tempSelectedToYear;
            }

            if (this.tempSelectedToYear - this.tempSelectedFromYear > 10) {
                this.tempSelectedToYear = this.tempSelectedFromYear + 10;
            }
        }
    }

    private prgByAbpCache: Record<string, any[]> = {};

    private async getCurProjectList() {
        if (this.loading || !this.hasMore) return;

        try {
            this.loading = true;
            this.bar = 0;

            const queryParams: any = {
                ...(this.selectedCode && {
                    code: this.selectedCode,
                    project_type: "current,other",
                }),
                obl: this.oblCode,
                ...(this.selectedRegion && {
                    budget_region: this.selectedRegion.code,
                }),
                ...(this.selectedAbp && { abp: this.selectedAbp.abp }),
                ...(this.selectedPrg && { prg: this.selectedPrg.prg }),
                ...(this.selectedRegSnp && {
                    location: this.selectedRegSnp.code,
                }),
                ...(this.selectedFromYear && {
                    begin_date: `${this.selectedFromYear}-01-01`,
                }),
                ...(this.selectedToYear && {
                    end_date: `${this.selectedToYear}-12-31`,
                }),
                ...(!this.selectedCode &&
                    this.selectedType && {
                        project_type: this.selectedType.code,
                    }),
                ...(this.isActive === true && { is_archive: false }),
                ...(this.isArchived === true && { is_archive: true }),
                ...(this.isActive === true &&
                    this.isArchived === true && {
                        is_archive: "false,true",
                    }),
            };

            const response = await axios.get(
                `api-py/get-project-bank-list/${this.userId}`,
                {
                    params: {
                        ...queryParams,
                        limit: this.limit,
                        offset: this.offset,
                    },
                }
            );

            const projects = response.data.data ?? [];

            if (
                this.offset === 0 &&
                (this.selectedType?.code === "other" ||
                    this.tpData.srcData === "other")
            ) {
                await this.getAbpWithoutRegion();
            }

            const abpCodesForPrg: number[] = Array.from(
                new Set(
                    projects
                        // .filter((item: any) => item.project_type !== "other")
                        .map((item: any) => Number(item.abp))
                        .filter((abp: number) => Number.isFinite(abp))
                )
            ) as number[];

            const abpCodesToLoad = abpCodesForPrg.filter(
                (abp: number) => !this.prgByAbpCache[abp]
            );

            if (abpCodesToLoad.length) {
                await Promise.all(
                    abpCodesToLoad.map((abpCode) =>
                        axios
                            .get(`/api-py/actual-prg-by-abp/${abpCode}`)
                            .then((res) => {
                                this.prgByAbpCache[abpCode] = res.data;
                            })
                    )
                );
            }

            const curProjectList = projects.map((item: any) => {
                const programs = this.prgByAbpCache[item.abp];
                const program = programs?.find(
                    (prg: any) => prg.prg === item.prg
                );

                const locCodes = Array.isArray(item.location)
                    ? item.location
                    : [item.location];

                const isKk = this.curLanguage === "kk";

                const locationNames = locCodes.map((code: string) => {
                    const region = this.regionsSnp.find(
                        (r: any) => r.code === code
                    );
                    if (!region) return code;
                    return isKk ? region.name_kk || region.name : region.name;
                });

                const abpItem = this.abpList.find(
                    (abp: any) => abp.abp === item.abp
                );

                return {
                    ...item,
                    srcData: item.project_type,
                    begin_date: item.begin_date
                        ? new Date(item.begin_date)
                        : null,
                    end_date: item.end_date ? new Date(item.end_date) : null,
                    projectStatus:
                        item.is_archive === true
                            ? String(
                                  this.$t(
                                      "modules.bank_projects.filter_params.status.archive"
                                  )
                              )
                            : String(
                                  this.$t(
                                      "modules.bank_projects.filter_params.status.active"
                                  )
                              ),
                    abpName: abpItem
                        ? isKk
                            ? abpItem.text_kk || abpItem.text
                            : abpItem.text
                        : item.abp,
                    prgName:
                        // item.project_type !== "other" &&
                        program
                            ? `${program.prg} - ${
                                  isKk
                                      ? program.name_kk ||
                                        program.name_kz ||
                                        program.name_ru
                                      : program.name_ru
                              }`
                            : item.prg,
                    locationNames: locationNames,
                    locationName: locationNames[0],
                };
            });

            if (this.offset === 0) {
                this.curProjectList = curProjectList;
            } else {
                this.curProjectList.push(...curProjectList);
            }

            this.offset += curProjectList.length;

            if (curProjectList.length < this.limit) {
                this.hasMore = false;
            }

            this.bar = 100;
        } catch (error) {
            this.notifyProjectListError(error);
        } finally {
            this.loading = false;
        }
    }

    private async getCodeList() {
        try {
            const projectType = "current,other";
            const response = await axios.get(
                `api-py/get-project-bank-code-list/${projectType}/${this.oblCode}/${this.userId}`
            );
            if (!Array.isArray(response.data)) {
                this.codeList = [];
                return;
            }
            this.codeList = response.data.map(
                (item: { code: string }) => item.code
            );
        } catch (error) {
            this.codeList = [];
            if (axios.isAxiosError(error) && error.response?.status === 403) {
                return;
            }
            this.makeToast(
                "danger",
                String(
                    this.$t("modules.bank_projects.messages.codes_load_err_msg")
                ),
                String(
                    this.$t("modules.bank_projects.messages.codes_req_err_msg")
                )
            );
        }
    }

    private notifyProjectListError(error: unknown) {
        const serverMessage = axios.isAxiosError(error)
            ? error.response?.data?.message
            : undefined;
        let accessKey = "";
        if (serverMessage === "No accessible ABPs for this user") {
            accessKey = "projects_no_abp_msg";
        } else if (
            serverMessage === "No accessible budget regions for this user"
        ) {
            accessKey = "projects_no_regions_msg";
        }
        if (accessKey) {
            this.makeToast(
                "danger",
                String(this.$t(`modules.bank_projects.messages.${accessKey}`)),
                String(
                    this.$t(
                        "modules.bank_projects.messages.projects_load_err_msg"
                    )
                )
            );
        } else if (error instanceof Error) {
            this.makeToast(
                "danger",
                error.message,
                String(
                    this.$t(
                        "modules.bank_projects.messages.projects_load_err_msg"
                    )
                )
            );
        }
    }

    private async loadRegion() {
        try {
            const response = await fetch(
                "/api-py/get-user-regions-by-obl/" +
                    this.oblCode +
                    "/" +
                    this.userId
            ).then((response) => response.json());
            this.regionList = response.map((item: any) => ({
                ...item,
                text: `${item.code} - ${item.name_ru}`,
                text_kk: `${item.code} - ${
                    item.name_kk || item.name_kz || item.name_ru
                }`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.budget_regions_req_err_msg"
                        )
                    ),
                    error.message
                );
            }
        } finally {
            this.selectedRegion = this.regionList[0];
            this.tempSelectedRegion = this.regionList[0];
        }
    }

    async fetchObl() {
        try {
            await fetch(
                "/api-py/get-budget-obl/" + this.$store.state._instanceCode
            )
                .then((response) => response.json())
                .then((json) => {
                    this.oblKato = json.obl;
                });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.region_code_req_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private async fetchAbp(regionCode: string): Promise<any[]> {
        try {
            const regionResponse = await fetch(
                `/api-py/get-abps-by-region/${regionCode}`
            );
            const abpsOfRegion = await regionResponse.json();

            const userResponse = await fetch(`/api-py/user-abp/${this.userId}`);
            const abpsOfUser = await userResponse.json();

            const userAbpsSet = new Set(
                abpsOfUser.map((item: any) => item.abp)
            );
            const availableAbps = abpsOfRegion.filter((item: any) =>
                userAbpsSet.has(item.abp)
            );

            const seenAbps = new Set();
            return availableAbps.filter((item: any) => {
                if (seenAbps.has(item.abp)) {
                    return false;
                }
                seenAbps.add(item.abp);
                return true;
            });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            return [];
        }
    }

    private async fetchPrg(abp: any): Promise<any[]> {
        try {
            const response = await fetch(
                `/api-py/actual-prg-by-abp/${abp.abp}`
            );
            const prgData = await response.json();
            return prgData
                .filter((item: any) => item.develop_type === 0)
                .map((item: any) => ({
                    ...item,
                    text: `${item.prg} - ${item.name_ru}`,
                    text_kk: `${item.prg} - ${
                        item.name_kk || item.name_kz || item.name_ru
                    }`,
                }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.program_req_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            return [];
        }
    }

    private async loadAbpData(region: any, isFilter: boolean) {
        if (region?.code) {
            const abpList = await this.fetchAbp(region.code);
            this.abpList = abpList
                .map((item: any) => ({
                    ...item,
                    text_kk: `${item.abp} - ${
                        item.name_kk || item.name_kz || item.name_ru
                    }`,
                }))
                .sort((a, b) => a.abp - b.abp);
            if (isFilter) {
                await this.loadPrgData(this.tempSelectedAbp);
            } else {
                await this.loadPrgData(this.selectedAbp);
            }
        }
    }

    private formatDateToYYYYMMDD(date: Date, isStart: boolean): string {
        const y = date.getFullYear();
        const m = (date.getMonth() + 1).toString().padStart(2, "0");
        const d = isStart
            ? "01"
            : new Date(y, date.getMonth() + 1, 0)
                  .getDate()
                  .toString()
                  .padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    private async loadAbpForCreation(): Promise<void> {
        let regionCode = this.selectedRegion?.code;

        if (
            !regionCode &&
            (this.isCodeSelected || this.mode === "edit") &&
            this.tpData?.budgetRegion
        ) {
            regionCode = this.tpData.budgetRegion.split(" ")[0];
        }

        if (!regionCode) {
            this.abpNewList = [];
            this.prgList = [];
            return;
        }

        const fromDate = this.tpData?.dateFromForInput;
        const toDate = this.tpData?.dateToForInput;

        if (!fromDate || !toDate) {
            this.abpNewList = [];
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.bank_projects.messages.abp_period_required_msg"
                    )
                ),
                String(this.$t("modules.bank_projects.messages.attention_msg"))
            );
            return;
        }

        const begDate = this.formatDateToYYYYMMDD(fromDate, true);
        const endDate = this.formatDateToYYYYMMDD(toDate, false);

        const url = `/api-py/get-user-abp-by-region-period?uid=${this.userId}&region=${regionCode}&begDate=${begDate}&endDate=${endDate}`;

        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const abps: any[] = await res.json();
            abps.sort((a, b) => Number(a.abp) - Number(b.abp));

            this.abpNewList = abps.map((item) => ({
                ...item,
                text: `${item.abp} - ${item.name_ru}`,
                text_kk: `${item.abp} - ${
                    item.name_kk || item.name_kz || item.name_ru
                }`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            this.abpNewList = [];
        }
    }

    private async loadPrgData(abp: any) {
        if (abp) {
            const prgList = await this.fetchPrg(abp);
            this.prgList = prgList;
        }
    }

    private async loadUserAbpByPeriod(): Promise<void> {
        const fromDate = this.tpData?.dateFromForInput;
        const toDate = this.tpData?.dateToForInput;

        if (!fromDate || !toDate) {
            this.abpNewList = [];
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.bank_projects.messages.abp_period_required_msg"
                    )
                ),
                String(this.$t("modules.bank_projects.messages.attention_msg"))
            );
            return;
        }

        const begDate = this.formatDateToYYYYMMDD(fromDate, true);
        const endDate = this.formatDateToYYYYMMDD(toDate, false);

        const url = `/api-py/get-user-abp-by-project-period?uid=${this.userId}&begDate=${begDate}&endDate=${endDate}`;

        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const response: AbpResponse = await res.json();
            const abps = response.abps ?? [];

            abps.sort((a, b) => Number(a.abp) - Number(b.abp));

            this.abpNewList = abps.map((item) => ({
                ...item,
                text: `${item.abp} - ${item.name_ru}`,
                text_kk: `${item.abp} - ${item.name_kk}`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            this.abpNewList = [];
        }
    }

    private async checkProjectAbp(abpCode: number): Promise<boolean> {
        if (
            !abpCode ||
            !this.tpData?.dateFromForInput ||
            !this.tpData?.dateToForInput
        ) {
            return true;
        }

        const begDate = this.formatDateToYYYYMMDD(
            this.tpData.dateFromForInput,
            true
        );
        const endDate = this.formatDateToYYYYMMDD(
            this.tpData.dateToForInput,
            false
        );

        const url = `/api-py/get-user-abp-by-project-period?uid=${this.userId}&begDate=${begDate}&endDate=${endDate}&currentAbp=${abpCode}`;

        try {
            const res = await fetch(url);
            if (!res.ok)
                throw new Error(
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_validation_err_msg"
                        )
                    )
                );

            const response: AbpResponse = await res.json();
            return !!response.currentAbpValid;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_validation_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
            return false;
        }
    }

    private async getAbpWithoutRegion() {
        try {
            this.abpList = [];
            const userResponse = await fetch(`/api-py/user-abp/${this.userId}`);
            const userAbpData = await userResponse.json();

            if (!userAbpData || userAbpData.length === 0) {
                this.makeToast(
                    "warning",
                    "Ошибка загрузки списка АБП",
                    "Сообщение"
                );
                return;
            }

            const allResponse = await fetch(
                `/api-py/get-dict-ved-abp-by-budgetlevel/[2,3,4]`
            );
            const allAbpData = await allResponse.json();

            const abpNamesMap = allAbpData.reduce((map: any, abp: any) => {
                map[abp.abp] = {
                    name_ru: abp.name_ru,
                    name_kk: abp.name_kk || abp.name_ru,
                };
                return map;
            }, {});

            this.abpList = userAbpData.map((item: any) => ({
                abp: item.abp,
                text: `${item.abp} - ${
                    abpNamesMap[item.abp]?.name_ru || "Не найдено"
                }`,
                text_kk: `${item.abp} - ${
                    abpNamesMap[item.abp]?.name_kk || "Не найдено"
                }`,
            }));

            this.abpList.sort((a, b) => a.abp - b.abp);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка загрузки списка АБП",
                    error.message
                );
            }
        }
    }

    private async loadRegionsSnp() {
        try {
            const snpResponse = await fetch("/api-py/user-kato/" + this.userId);
            const snpData = await snpResponse.json();

            if (snpData && snpData.length > 0) {
                const katoResponse = await fetch(
                    "/api-py/get-katos-by-obl/" + this.oblCode
                );
                const katoData = await katoResponse.json();
                this.regionsSnp = snpData.map((item: any) => {
                    const foundRegion = katoData.find(
                        (region: any) => region.code === item.kato
                    );
                    return {
                        code: item.kato,
                        name: foundRegion ? foundRegion.name_ru : "",
                        name_kk: foundRegion
                            ? foundRegion.name_kz || foundRegion.name_ru
                            : "",
                        text: `${item.kato} - ${
                            foundRegion ? foundRegion.name_ru : ""
                        }`,
                        text_kk: `${item.kato} - ${
                            foundRegion
                                ? foundRegion.name_kz || foundRegion.name_ru
                                : ""
                        }`,
                    };
                });
            } else {
                this.regionsSnp = [];
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.snp_regions_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private async getFundingSrc() {
        try {
            const response = await axios.get("api-py/dict_funding_source");
            this.fundingSrcList = response.data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.fin_source_types_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private async getProjectBranches() {
        try {
            const response = await axios.get("api-py/dict_project_branch");
            this.branchList = response.data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.sectors_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private async getProjectPrg() {
        try {
            const response = await axios.get("api-py/dict_program");
            this.projectPrgList = response.data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.project_types_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private async getUnits() {
        try {
            const response = await axios.get(
                "api-py/get_dict_project_bank_units"
            );
            this.unitList = response.data.map((unit: any) => ({
                ...unit,
                text: `${unit.name_ru}`,
                text_kk: `${unit.name_kz}`,
            }));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.units_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private async getIndicatorList() {
        try {
            const response = await axios.get("/api/dict/program_goals");
            this.goalIndicatorList = response.data;
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.target_indicator_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        let refItem: any;
        switch (refName) {
            case "code":
                refItem = this.$refs.code;
                break;
            case "region":
                refItem = this.$refs.region;
                break;
            case "abp":
                refItem = this.$refs.abp;
                break;
            case "prg":
                refItem = this.$refs.prg;
                break;
            case "snpReg":
                refItem = this.$refs.snpReg;
                break;
            case "period":
                refItem = this.$refs.period;
                break;
            case "status":
                refItem = this.$refs.status;
                break;
        }
        setTimeout(() => refItem.$el.focus(), 100);
    }

    private clickLoadBtn() {
        this.isAddModalVisible = true;
    }

    private createNewProject() {
        this.resetTpData();
        this.$root.$emit("bv::hide::modal", "add-project-modal");
        this.mode = "create";
        this.showDetailForm = true;
        this.backList = false;
        this.selectedBranch = null;
        this.selectedFunding = null;
        this.selectedProjectPrg = null;
        this.selectedUnit = null;
        this.selectedType = {
            code: "current",
            text: this.$t(
                "modules.bank_projects.filter_params.type_exp.cur_prj"
            ),
        };
        this.resetFilterData();
        this.selectedRegion = this.regionList[0];
        this.$root.$emit("removeClass");
    }

    private formatDateToMMYYYY(date: Date | string | null): string {
        if (!date) return "";
        const d = new Date(date);
        const month = (d.getMonth() + 1).toString().padStart(2, "0");
        const year = d.getFullYear();
        return `${month}/${year}`;
    }

    private getRegionName(code: string) {
        const region = this.regionList.find((r: any) => r.code === code);
        if (!region) return "";
        return this.curLanguage === "kk"
            ? region.text_kk || region.text
            : region.text;
    }

    private async getAbpNameWithFallback(abp: string, region: string) {
        if (!abp) return "";
        const isKk = this.curLanguage === "kk";
        const abpItem = this.abpList.find((a: any) => a.abp === abp);
        const abpName = isKk
            ? abpItem?.text_kk || abpItem?.text
            : abpItem?.text;
        if (!abpName && region) {
            const abpResponse = await fetch(
                `/api-py/get-abps-by-region/${region}`
            );
            const abpData = await abpResponse.json();
            const found = abpData.find((a: any) => a.abp === abp);
            if (!found) return "";
            return isKk
                ? found.name_kk || found.name_kz
                    ? `${found.abp} - ${found.name_kk || found.name_kz}`
                    : found.text_kk || found.text || ""
                : found.text || "";
        }
        return abpName || "";
    }

    private async getPrgNameWithFallback(prg: string, abp: string) {
        if (!abp) return "";
        const isKk = this.curLanguage === "kk";
        const prgItem = this.prgList.find((p: any) => p.prg === prg);
        const prgName = isKk
            ? prgItem?.text_kk || prgItem?.text
            : prgItem?.text;
        if (!prgName && abp) {
            const prgResponse = await fetch(`/api-py/actual-prg-by-abp/${abp}`);
            const prgData = await prgResponse.json();
            const program = prgData.find((p: any) => p.prg === prg);
            if (!program) return "";
            return isKk
                ? `${program.prg} - ${
                      program.name_kk || program.name_kz || program.name_ru
                  }`
                : `${program.prg} - ${program.name_ru}`;
        }
        return prgName || "";
    }

    private getLocationName(code: string) {
        const region = this.regionsSnp.find((r: any) => r.code === code);
        if (!region) return "";
        return this.curLanguage === "kk"
            ? region.text_kk || region.text
            : region.text;
    }

    private getUnitName(code: string) {
        const unit = this.unitList.find((u: any) => u.code === code);
        if (!unit) return "";
        return this.curLanguage === "kk"
            ? unit.text_kk || unit.text
            : unit.text;
    }

    private getBranchName(code: string) {
        const branch = this.branchList.find((b: any) => b.code === code);
        if (!branch) return "";
        return this.curLanguage === "kk"
            ? branch.name_kk || branch.name_kz || branch.name_ru
            : branch.name_ru;
    }

    private getProjectPrgName(code: string) {
        const prg = this.projectPrgList.find((p: any) => p.code === code);
        if (!prg) return "";
        return this.curLanguage === "kk"
            ? prg.name_kk || prg.name_kz || prg.name_ru
            : prg.name_ru;
    }

    private getFundingName(code: string) {
        const fund = this.fundingSrcList.find((f: any) => f.code === code);
        if (!fund) return "";
        return this.curLanguage === "kk"
            ? fund.name_kk || fund.name_kz || fund.name_ru
            : fund.name_ru;
    }

    private async getDetailProjectInfo(item: any) {
        try {
            const response = await fetch(
                `/api-py/get-project-bank-details/${item.id}`
            );
            const projectDetails = await response.json();
            const project = projectDetails.project;

            const conceptCodes: string[] = projectDetails.concept;
            const locationCodes: string[] = projectDetails.location;

            const regionName = this.getRegionName(project.budget_region);
            const branchName = this.getBranchName(project.branch);
            const fundingName = this.getFundingName(project.funding);

            let abpName = "";
            let prgName = "";

            if (project.project_type === "other") {
                await this.getAbpWithoutRegion();

                const abp = this.abpList.find(
                    (abp: any) => abp.abp === project.abp
                );

                if (this.curLanguage === "kk") {
                    abpName = abp?.text_kk || "";
                } else {
                    abpName = abp?.text || "";
                }

                prgName = await this.getPrgNameWithFallback(
                    project.prg,
                    project.abp
                );
            } else {
                [abpName, prgName] = await Promise.all([
                    this.getAbpNameWithFallback(
                        project.abp,
                        project.budget_region
                    ),
                    this.getPrgNameWithFallback(project.prg, project.abp),
                ]);
            }

            this.tpData = {
                ...this.tpData,
                id: project.id,
                code: project.code || this.tpData.code,
                nameRu: project.name_ru || this.tpData.nameRu,
                nameKk: project.name_kz || this.tpData.nameKk,
                projectStatus:
                    project.is_archive === true ? "archived" : "active",
                budgetRegion: regionName || this.tpData.budgetRegion,
                abp: abpName || this.tpData.abp,
                prg: prgName || this.tpData.prg,
                dateFromForInput:
                    new Date(project.begin_date) ||
                    this.tpData.dateFromForInput,
                dateToForInput:
                    new Date(project.end_date) || this.tpData.dateToForInput,
                location: locationCodes || this.tpData.location,
                budgetAmount: project.amount_budget || this.tpData.budgetAmount,
                srcFunding: fundingName || this.tpData.srcFunding,
                projectBranch: branchName || this.tpData.projectBranch,
                projectConcept: conceptCodes || this.tpData.projectConcept,
                srcData: project.project_type || this.tpData.srcData,
                actDate: project.date_act_commission
                    ? new Date(project.date_act_commission)
                    : null,
                goals: projectDetails.goals,
                period_start_year: project.period_start_year,
                period_end_year: project.period_end_year,
                plan:
                    projectDetails.plan_values.map((pv: any) => ({
                        year: pv.year,
                        value: pv.value,
                    })) || this.tpData.plan,
            };
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.project_detail_load_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private backToProjectList() {
        this.showDetailForm = false;
        this.backList = true;
        this.isSaving = false;
        this.isEditing = false;
        this.resetTpData();
        this.changeData();
        this.showCloseModal = false;
        this.isEdited = false;
        this.validationErrors = {};
        this.$root.$emit("removeNoTabs");
    }

    private async changeData() {
        try {
            this.selectedType = this.tempSelectedType;
            this.selectedRegion = this.tempSelectedRegion;
            this.selectedAbp = this.tempSelectedAbp;
            this.selectedPrg = this.tempSelectedPrg;
            this.selectedRegSnp = this.tempSelectedRegSnp;
            this.selectedCode = this.tempSelectedCode;
            this.selectedFromYear = this.tempSelectedFromYear;
            this.selectedToYear = this.tempSelectedToYear;
            this.isActive = this.tempIsActive;
            this.isArchived = this.tempIsArchived;

            this.offset = 0;
            this.hasMore = true;
            this.curProjectList = [];
            await this.getCurProjectList();

            if (this.selectedCode) {
                this.selectedRegion = null;
            }

            this.$refs.drop.hide(true);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.projects_load_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    private resetTpData() {
        this.tpData = new CurProjectDataClass();
        this.selectedAbp = null;
        this.selectedPrg = null;
        this.selectedRegSnp = null;
        this.selectedBranch = null;
        this.selectedFunding = null;
        this.selectedProjectPrg = null;
        this.selectedUnit = null;
        this.isArchived = true;
        this.isArchived = true;
        this.selectedFromYear = new Date().getFullYear();
        this.selectedToYear = null;
    }

    private originalFormData: any = null;

    private async openProject(item: any) {
        this.mode = "view";
        await this.getDetailProjectInfo(item);
        const abpCode = Number(this.tpData.abp.split(" - ")[0]);

        if (abpCode) {
            const isAbpValid = await this.checkProjectAbp(abpCode);
            if (!isAbpValid) {
                this.makeToast(
                    "warning",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.abp_period_conflict_msg"
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.attention_msg")
                    )
                );
                this.tpData.abp = "";
            }
        }

        this.originalTpData = JSON.parse(JSON.stringify(this.tpData));

        this.$nextTick(() => {
            this.originalFormData = JSON.parse(
                JSON.stringify((this.$refs.tpCard as any).getFormData())
            );
        });
        this.isEditing = false;
        this.showDetailForm = true;
        this.backList = false;
        this.backProjectCardForm = true;
        this.$root.$emit("removeClass");
    }

    private checkIfEdited(): boolean {
        const currentFormData = (this.$refs.tpCard as any).getFormData();

        const isEdited =
            JSON.stringify(currentFormData) !==
            JSON.stringify(this.originalFormData);

        if (this.mode === "create") {
            const hasFilledFields =
                !!this.tpData.nameRu?.trim() || !!this.tpData.nameKk?.trim();

            return hasFilledFields;
        }

        this.isEdited = isEdited;
        return isEdited;
    }

    private openCloseModal() {
        const edited = this.checkIfEdited();
        if (
            edited &&
            (this.mode === "edit" || (!this.isSaving && this.mode === "create"))
        ) {
            this.showCloseModal = true;
        } else {
            this.backToProjectList();
        }
    }

    private closeGoalCard() {
        this.backProjectCardForm = true;
        this.handleResetTaskList();
        this.validationErrors = {};
    }

    @Watch("activeTab")
    private onActiveTabChange(newTab: number, oldTab: number) {
        if (newTab !== oldTab) {
            this.backToProjectList();
        }
    }

    private validationErrors: any = {};

    private validateFieldLength(
        fieldKey: string,
        maxLength: number,
        fieldName: string
    ) {
        const fieldValue = eval(`this.${fieldKey}`);
        const textLength = Array.from(fieldValue).length;

        if (textLength > maxLength) {
            this.validationErrors[fieldKey] = true;
            this.makeToast(
                "warning",
                String(
                    this.$t(
                        "modules.bank_projects.messages.limit_symbols_err_msg",
                        { f: fieldName, l: maxLength }
                    )
                ),
                String(this.$t("modules.bank_projects.messages.attention_msg"))
            );
            return false;
        }
        return true;
    }

    private validatePositiveSum(fieldKey: string, fieldName: string) {
        const fieldValue = eval(`this.${fieldKey}`);

        if (fieldValue && fieldValue < 0) {
            this.validationErrors[fieldKey] = true;
            this.makeToast(
                "danger",
                String(
                    this.$t(
                        "modules.bank_projects.messages.positive_value_err_msg",
                        { f: fieldName }
                    )
                ),
                String(this.$t("modules.bank_projects.messages.saving_err_msg"))
            );
            return false;
        }
    }

    handleValidationComplete(errors: any) {
        this.validationErrors = errors;
    }

    private containsInvalidChars(value: any): boolean {
        const INVALID_CONTROL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;
        return typeof value === "string" && INVALID_CONTROL_CHARS.test(value);
    }

    private validateForm() {
        this.validationErrors = {};
        const isLengthValid = this.validateFieldLengths();

        const statusActive: boolean = this.tpData.projectStatus === "active";
        const isPlanValid = this.$refs.tpCard.validatePlanValues(statusActive);

        if (!isLengthValid) {
            return false;
        }

        const requiredFields = [
            {
                key: "tpData.nameKk",
                message: String(
                    this.$t("modules.bank_projects.input_form.prj_name_kk")
                ),
            },
            {
                key: "tpData.nameRu",
                message: String(
                    this.$t("modules.bank_projects.input_form.prj_name_ru")
                ),
            },
            {
                key: this.mode === "edit" ? "tpData.abp" : "selectedAbp?.abp",
                message: String(
                    this.$t("modules.bank_projects.filter_params.abp")
                ),
            },
            {
                key:
                    this.mode === "edit"
                        ? this.tpData.prg
                            ? "tpData.prg"
                            : "selectedPrg?.text"
                        : "selectedPrg?.prg",
                message: String(
                    this.$t("modules.bank_projects.input_form.prg")
                ),
            },
            {
                key: "tpData.dateFromForInput",
                message: String(
                    this.$t("modules.bank_projects.messages.start_date")
                ),
            },
            {
                key: "tpData.dateToForInput",
                message: String(
                    this.$t("modules.bank_projects.messages.end_date")
                ),
            },
        ];

        if (this.tpData.srcData === "current") {
            requiredFields.push(
                {
                    key:
                        this.mode === "edit"
                            ? "tpData.budgetRegion"
                            : "selectedRegion?.code",
                    message: String(
                        this.$t("modules.bank_projects.filter_params.region")
                    ),
                },
                // {
                //     key:
                //         this.mode === "edit"
                //             ? this.tpData.prg
                //                 ? "tpData.prg"
                //                 : "selectedPrg?.text"
                //             : "selectedPrg?.prg",
                //     message: String(
                //         this.$t("modules.bank_projects.input_form.prg")
                //     ),
                // },
                {
                    key: this.selectedBranch?.code
                        ? "selectedBranch?.code"
                        : "tpData.projectBranch",
                    message: String(
                        this.$t("modules.bank_projects.input_form.sector")
                    ),
                }
            );
        } else if (this.tpData.srcData === "other") {
            requiredFields.push();
        }

        for (const field of requiredFields) {
            const value = eval(`this.${field.key}`);

            if (typeof value === "string" && this.containsInvalidChars(value)) {
                this.validationErrors[field.key] = true;
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.invalid_symbols_err_msg",
                            { f: field.message }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.saving_err_msg")
                    )
                );
                continue;
            }

            if (!value || (typeof value === "string" && value.trim() === "")) {
                this.validationErrors[field.key] = true;
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.missing_field_err",
                            { f: field.message }
                        )
                    ),
                    String(
                        this.$t("modules.bank_projects.messages.saving_err_msg")
                    )
                );
            } else {
                this.validationErrors[field.key] = false;
            }
        }

        return Object.keys(this.validationErrors).every(
            (key) => !this.validationErrors[key]
        );
    }

    private validateFieldLengths(): boolean {
        const textLimit255 = 255;

        const validations = [
            this.validateFieldLength(
                "tpData.nameKk",
                textLimit255,
                String(this.$t("modules.bank_projects.input_form.prj_name_kk"))
            ),
            this.validateFieldLength(
                "tpData.nameRu",
                textLimit255,
                String(this.$t("modules.bank_projects.input_form.prj_name_ru"))
            ),
            this.validatePositiveSum(
                "tpData.localBudgetAmount",
                String(this.$t("modules.bank_projects.input_form.sum_budget"))
            ),
            this.validatePositiveSum(
                "tpData.republicanBudgetAmount",
                String(
                    this.$t("modules.bank_projects.input_form.sum_rep_budget")
                )
            ),
        ];

        return !validations.includes(false);
    }

    private async saveProjectData() {
        if (!this.validateForm()) {
            return;
        }
        this.isSaving = true;

        try {
            const formData = (this.$refs.tpCard as any).getFormData();

            const response = await axios.post(
                "/api-py/save-project-bank-data",
                formData
            );

            if (response.status === 200) {
                const {
                    result,
                    message,
                    error_code,
                    field,
                    project_code,
                    usage_modes,
                } = response.data;

                if (result === "success") {
                    this.$emit("messageSent", response.data);
                    this.makeToast(
                        "success",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.record_saved_msg"
                            )
                        ),
                        String(
                            this.$t(
                                "modules.bank_projects.messages.project_save_msg"
                            )
                        )
                    );
                    this.isEditing = false;
                    this.mode = "view";
                    this.isEdited = false;
                    if (this.tpData && this.tpData.srcData === "other") {
                        await this.getAbpWithoutRegion();
                    }
                    await this.getDetailProjectInfo({ id: response.data.id });

                    this.getCurProjectList();
                } else if (error_code === "prj_edit_forbidden") {
                    const modes = this.formatUsageModes(usage_modes);

                    this.makeToast(
                        "warning",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.project_edit_forbidden",
                                {
                                    field: this.getFieldName(field),
                                    code: project_code,
                                    mode: modes,
                                }
                            )
                        ),
                        String(
                            this.$t(
                                "modules.bank_projects.messages.data_save_err_msg"
                            )
                        )
                    );

                    this.isEdited = false;
                    this.isEditing = false;
                    this.mode = "view";

                    await this.getDetailProjectInfo({ id: formData.id });
                } else {
                    this.makeToast(
                        "warning",
                        message,
                        String(
                            this.$t(
                                "modules.bank_projects.messages.project_save_msg"
                            )
                        )
                    );
                }
            } else {
                throw new Error(
                    String(
                        this.$t("modules.bank_projects.messages.server_err_msg")
                    ) + `: ${response.status}`
                );
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.data_save_err_msg"
                        )
                    ),
                    error.message
                );
            }
        }
    }

    private getFieldName(field: string): string {
        return String(this.$t(`modules.bank_projects.input_form.${field}`));
    }

    sendGoals() {
        const tpCard = this.$refs.tpCard as any;
        if (!tpCard) return;
        const goalCard = tpCard?.$refs?.goalTpCard;

        if (goalCard) {
            goalCard.resetTaskList();

            const isGoalValid = goalCard.validateGoalForm();
            if (!isGoalValid) {
                return;
            }
        }

        if (tpCard && tpCard.saveGoalsFromGoalCard) {
            tpCard.saveGoalsFromGoalCard();
            this.validationErrors = {};
        }

        this.backProjectCardForm = true;
        this.handleResetTaskList();
    }

    private resetFilterData() {
        this.tempSelectedCode = null;
        this.tempSelectedType = {
            code: "current",
            text: this.$t(
                "modules.bank_projects.filter_params.type_exp.cur_prj"
            ),
        };
        this.tempSelectedRegion = this.regionList[0];
        this.tempSelectedAbp = null;
        this.tempSelectedPrg = null;
        this.prgList = [];
        this.tempSelectedRegSnp = null;
        this.tempIsActive = true;
        this.tempIsArchived = true;
        this.tempSelectedFromYear = new Date().getFullYear();
        this.tempSelectedToYear = null;
    }

    private resetFiltersForCode() {
        this.tempSelectedType = null;
        this.tempSelectedRegion = null;
        this.tempSelectedAbp = null;
        this.tempSelectedPrg = null;
        this.tempSelectedRegSnp = null;
        this.tempIsActive = false;
        this.tempIsArchived = false;
        this.tempSelectedFromYear = 0;
        this.tempSelectedToYear = 0;
    }

    private resetFilterForOtherType() {
        this.tempSelectedRegion = null;
        this.tempSelectedPrg = null;
        this.tempSelectedRegSnp = null;
    }

    private confirmDeleteProject(item: CurProjectDataClass) {
        this.selectedProject = item;
        this.showDelModal = true;
    }

    private formatUsageModes(usage_modes: string[] | undefined): string {
        const modeNames: Record<UsageMode, string> = {
            transfers: String(
                this.$t("modules.bank_projects.mode_info.transfers")
            ),
            alteration: String(
                this.$t("modules.bank_projects.mode_info.alteration")
            ),
            ipf: String(this.$t("modules.bank_projects.mode_info.ipf")),
            events: String(this.$t("modules.bank_projects.mode_info.events")),
        };

        return (usage_modes || [])
            .map((mode: string) => `«${modeNames[mode as UsageMode]}»`)
            .join(", ");
    }

    private async deleteProject() {
        if (this.selectedProject) {
            try {
                const id = this.selectedProject.id;
                const response = await axios.delete(
                    "api-py/delete-project-banks-item",
                    {
                        data: { id },
                    }
                );
                const {
                    result,
                    message,
                    error_code,
                    project_code,
                    usage_modes,
                } = response.data;

                if (response.status === 200) {
                    if (result === "success") {
                        this.$emit("messageSent", response.data);
                        this.makeToast(
                            "success",
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.project_deleted_msg"
                                )
                            ),
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.project_delete_msg"
                                )
                            )
                        );
                        await this.getCurProjectList();
                    } else if (error_code === "prj_del_forbidden") {
                        const modes = this.formatUsageModes(usage_modes);

                        this.makeToast(
                            "warning",
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.project_delete_forbidden",
                                    {
                                        code: project_code,
                                        mode: modes,
                                    }
                                )
                            ),
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.project_delete_err_msg"
                                )
                            )
                        );
                    } else {
                        this.makeToast(
                            "warning",
                            message,
                            String(
                                this.$t(
                                    "modules.bank_projects.messages.project_delete_msg"
                                )
                            )
                        );
                    }
                } else {
                    throw new Error(
                        String(
                            this.$t(
                                "modules.bank_projects.messages.server_err_msg"
                            )
                        ) + `: ${response.status}`
                    );
                }
            } catch (error) {
                if (error instanceof Error) {
                    this.makeToast(
                        "danger",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.project_delete_err_msg"
                            )
                        ),
                        error.toString()
                    );
                }
            }
        }
        this.showDelModal = false;
        await this.getCodeList();
    }

    private cancelDelete() {
        this.showDelModal = false;
        this.selectedProject = null;
    }

    private async getPrgForTpData() {
        if (!this.tpData?.abp) {
            this.prgList = [];
            return;
        }

        const [code] = this.tpData.abp.split(" - ");

        try {
            const response = await fetch(`/api-py/actual-prg-by-abp/${code}`);

            if (!response.ok) {
                throw new Error(
                    String(
                        this.$t(
                            "modules.bank_projects.messages.program_req_err_msg"
                        )
                    )
                );
            }

            const prgData = await response.json();
            const formattedPrgData = prgData
                .filter((item: any) => item.develop_type === 0)
                .map((item: any) => ({
                    ...item,
                    text: `${item.prg} - ${item.name_ru}`,
                    text_kk: `${item.prg} - ${
                        item.name_kk || item.name_kz || item.name_ru
                    }`,
                }));
            this.prgList = formattedPrgData;

            if (this.mode === "edit" && this.tpData.prg) {
                const prgCode = this.tpData.prg.split(" - ")[0].trim();
                const selected = this.prgList.find(
                    (p: any) => p.prg.toString().trim() === prgCode
                );
                if (selected) {
                    this.selectedPrg = selected;
                    this.tpData.prg = selected.text;
                }
            }
        } catch (error) {
            console.error("Ошибка при загрузке программы:", error);
        }
    }

    private editProjectData() {
        this.mode = "edit";
        this.isEditing = true;
        this.isSaving = false;

        this.selectedRegion = null;
        this.selectedAbp = null;
        this.selectedPrg = null;
        this.selectedRegSnp = null;
        this.selectedFunding = null;
        this.selectedProjectPrg = null;
        this.selectedBranch = null;
        this.selectedUnit = null;
        this.selectedIndicator = null;

        this.getPrgForTpData();
    }

    private async downloadInfo() {
        if (this.loading) {
            this.makeToast(
                "info",
                String(this.$t("modules.bank_projects.messages.attention_msg")),
                String(
                    this.$t("modules.bank_projects.messages.download_start_msg")
                )
            );
        } else {
            this.loading = true;
            await axios({
                method: "post",
                url: "/api-py/get-info/38",
                responseType: "blob",
                data: null,
            })
                .then((response) => response.data)
                .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    const titleOfFile =
                        "Инструкция_Банк_Проектов_текущие_расходы";
                    link.setAttribute("download", titleOfFile + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                    this.makeToast(
                        "danger",
                        String(
                            this.$t(
                                "modules.bank_projects.messages.user_guide_req_err_msg"
                            )
                        ),
                        error.toString()
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }

    private formatNumber(value: number): string {
        return new Intl.NumberFormat("ru-RU", {
            style: "decimal",
            maximumFractionDigits: 1,
            minimumFractionDigits: 1,
        }).format(value);
    }

    private async downloadProjectList() {
        try {
            if (
                this.selectedType?.code === "current" ||
                (this.selectedCode &&
                    this.curProjectList[0].srcData === "current")
            ) {
                const response = await axios.get(
                    `/api-py/download-project-bank-cur-exp-list/${this.userId}`,
                    {
                        params: {
                            ...(this.selectedCode && {
                                code: this.selectedCode,
                            }),
                            obl: this.oblCode,
                            ...(this.selectedRegion && {
                                budget_region: this.selectedRegion.code,
                            }),
                            ...(this.selectedAbp && {
                                abp: this.selectedAbp.abp,
                            }),
                            ...(this.selectedPrg && {
                                prg: this.selectedPrg.prg,
                            }),
                            ...(this.selectedRegSnp && {
                                location: this.selectedRegSnp.code,
                            }),
                            ...(this.selectedFromYear && {
                                begin_date: `${this.selectedFromYear}-01-01`,
                            }),
                            ...(this.selectedToYear && {
                                end_date: `${this.selectedToYear}-12-31`,
                            }),
                            project_type: "current",
                            ...(this.isActive === true && {
                                is_archive: false,
                            }),
                            ...(this.isArchived === true && {
                                is_archive: true,
                            }),
                            ...(this.isActive === true &&
                                this.isArchived === true && {
                                    is_archive: "false,true",
                                }),
                            locale: this.curLanguage,
                        },
                        responseType: "blob",
                    }
                );
                const contentDisposition =
                    response.headers["content-disposition"];
                let filename = "Проект.xlsx";

                if (contentDisposition) {
                    const match = contentDisposition.match(
                        /filename\*?=['"]?UTF-8['"]?''([^;]*)/
                    );
                    if (match && match[1]) {
                        filename = decodeURIComponent(match[1]);
                    }
                }
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            } else if (
                this.selectedType?.code === "other" ||
                (this.selectedCode &&
                    this.curProjectList[0].srcData === "other")
            ) {
                const response = await axios.get(
                    `/api-py/download-project-bank-other-exp-list/${this.userId}`,
                    {
                        params: {
                            ...(this.selectedCode && {
                                code: this.selectedCode,
                            }),
                            obl: this.oblCode,
                            ...(this.selectedAbp && {
                                abp: this.selectedAbp.abp,
                            }),
                            ...(this.selectedPrg && {
                                prg: this.selectedPrg.prg,
                            }),
                            ...(this.selectedFromYear && {
                                begin_date: `${this.selectedFromYear}-01-01`,
                            }),
                            ...(this.selectedToYear && {
                                end_date: `${this.selectedToYear}-12-31`,
                            }),
                            project_type: "other",
                            ...(this.isActive === true && {
                                is_archive: false,
                            }),
                            ...(this.isArchived === true && {
                                is_archive: true,
                            }),
                            ...(this.isActive === true &&
                                this.isArchived === true && {
                                    is_archive: "false,true",
                                }),
                            locale: this.curLanguage,
                        },
                        responseType: "blob",
                    }
                );
                const contentDisposition =
                    response.headers["content-disposition"];
                let filename = "Проект.xlsx";

                if (contentDisposition) {
                    const match = contentDisposition.match(
                        /filename\*?=['"]?UTF-8['"]?''([^;]*)/
                    );
                    if (match && match[1]) {
                        filename = decodeURIComponent(match[1]);
                    }
                }
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    String(
                        this.$t(
                            "modules.bank_projects.messages.file_download_err_msg"
                        )
                    ),
                    error.toString()
                );
            }
        }
    }

    handleResetTaskList() {
        if (this.$refs.tpCard) {
            (this.$refs.tpCard as any).handleResetTaskList();
        }
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
            solid: true,
            appendToast: true,
        });
    }
}
